import { useEffect, useRef, useState } from 'react';

export const useElementObserver = (elementId: string): HTMLElement | null => {
  const [targetElement, setTargetElement] = useState<HTMLElement | null>(null);
  const observerRef = useRef<MutationObserver | null>(null);

  useEffect(() => {
    const existingElement = document.querySelector(`#${elementId}`);
    if (existingElement) {
      setTargetElement(existingElement as HTMLElement);
      return;
    }

    observerRef.current = new MutationObserver(() => {
      const element = document.querySelector(`#${elementId}`);
      if (element) {
        setTargetElement(element as HTMLElement);
        observerRef.current?.disconnect();
      }
    });

    observerRef.current.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // eslint-disable-next-line consistent-return
    return () => observerRef.current?.disconnect();
  }, [elementId]);

  return targetElement;
};
